import { includes } from 'lodash-es'
import { daysOfWeek } from 'constants/transactionsExport'
import {
  ReportSchedule,
  ReportScheduleFrequency,
  ReportScheduleTimeZone,
} from 'types/transactionsExport'

export const getDayOfWeek = (id: number) => {
  const day = daysOfWeek?.find(day => Number(day?.value) === id)

  return day?.leftText
}

export const getUserTimezone = () => {
  const localDate = new Date()

  const timezoneOffset = localDate?.getTimezoneOffset()

  const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60)
  const offsetMinutes = Math.abs(timezoneOffset) % 60
  const sign = timezoneOffset > 0 ? '-' : '+'
  const formattedOffset = `UTC${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`

  return formattedOffset
}

export const getUserDefaultTimezone = (timezones: ReportScheduleTimeZone[]) => {
  const userTimezone = getUserTimezone()
  const timezone = timezones?.find(timezone => includes(timezone?.label, userTimezone))

  return timezone
}

export const getScheduleDescription = (
  reportSchedule: ReportSchedule,
  t: (str: string) => string
) => {
  if (!reportSchedule) {
    return ''
  }

  const formatInfo = reportSchedule.format?.toUpperCase()
  const timeFormatInfo = `${reportSchedule.time}, ${reportSchedule.timezone}, ${formatInfo}`

  switch (reportSchedule.frequencyType) {
    case ReportScheduleFrequency.DAILY:
      return `${t('exports.daily')}, ${timeFormatInfo}`

    case ReportScheduleFrequency.WEEKLY:
      return `${t('exports.weekly')}, ${getDayOfWeek(reportSchedule.frequencyDay)}, ${timeFormatInfo}`

    case ReportScheduleFrequency.MONTHLY:
      return `${t('exports.firstOfMonth')} ${timeFormatInfo}`

    default:
      return ''
  }
}
